<template>
  <div class="teams">
    <h1 class="page-title">Switch teams</h1>

    <div class="page-content -column -column-one -form">
      <ul class="section-nav">
        <li v-for="team in teams" :key="team.id" :class="{ '-active': team.id === currentTeam.id }">
          <a href="#" @click.prevent="selectTeam(team)">{{ team.name }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import auth from "@/helpers/auth";
import realtime from "@/helpers/realtime";

export default {
  beforeRouteEnter(to, from, next) {
    if (!auth.signedIn()) return next("/sign-in");
    next();
  },

  data() {
    return { teams: [] };
  },

  computed: {
    ...mapGetters(["currentUser", "currentTeam"])
  },

  watch: {
    currentUser() {
      this.setTeams();
    }
  },

  created() {
    this.setTeams();
  },

  methods: {
    setTeams() {
      if (this.currentUser) {
        this.teams = this.currentUser.teams.sort((x, y) => {
          return x.name < y.name ? -1 : x.name > y.name ? 1 : 0;
        });
      }
    },

    selectTeam(team) {
      localStorage.setItem("teamId", team.hashid);

      realtime.unsubscribeAll();

      this.$store.dispatch("loadInitialData");
      this.$router.push({ path: "/" });
    }
  }
};
</script>
